import { JetView } from "webix-jet";
import { devConfig, profile } from "config/config";

export default class tableSportsPoolReportView extends JetView {
    /**
     * Configures the UI components for the view
     * @returns {Object} Configuration object for the view
     */
    config() {
        const _ = this.app.getService("locale")._;
        const vthis = this;

        return {
            rows: [
                {
                    view: "datatable", // Main datatable for summarized report
                    id: "datatable",
                    css: "webix_header_border webix_data_border webix_footer_border", // Styling with borders
                    scrollY: true, // Enable vertical scroll
                    tooltip: true, // Enable tooltips
                    math: true, // Enable math operations
                    loadahead: 0, // Disable prefetch
                    datafetch: devConfig.getDefaultDataFetch(), // Batch size for server requests
                    pager: "pagerA", // Linked pager
                    footer: true, // Show footer row

                    data: [], // Empty initial dataset

                    columns: [
                        {
                            id: "detail", // Column with detail button
                            header: { text: "Ver Detalle", css: { "text-align": "center" } },
                            width: 120,
                            tooltip: _("Reporte Detallado"),
                            template: () => {
                                return `<div style="display:flex;justify-content:center;align-items:center;height:100%;">
                                    <span class="webix_icon wxi-search cursor-pointer detailBtn"></span>
                                </div>`;
                            },
                        },
                        {
                            id: "forecastId", // Forecast ID column
                            header: _("ID Polla"),
                            width: 150,
                            footer: "Total:"
                        },
                        {
                            id: "codePenka", // penkaCode ID column
                            header: _("Código de la polla"),
                            width: 150
                        },
                        {
                            id: "PenkaStartDate", // Date from column
                            header: _("Fecha de inicio"),
                            width: 150,
                            template: (obj) => obj.PenkaStartDate
                                ? obj.PenkaStartDate.split(' ')[0]
                                : ''
                        },
                        {
                            id: "betAmount", // Total number of bets placed in the Penka
                            header: _("Cantidad de Apuestas"),
                            width: 180
                        },
                        {
                            id: "nameOfPenka", // Name of the Penka (free or paid)
                            header: _("Nombre de la Penka"),
                            width: 180
                        },
                        {
                            id: "freeOrPaidPenka", // Indicates whether the Penka is free or paid
                            header: _("¿Penka gratuita o pagada?"),
                            width: 180
                        },
                        {
                            id: "EntranceFeeToThePenka", // Entry fee required to participate in the Penka
                            header: _("Valor de entrada a la Penka"),
                            width: 180
                        },
                        {
                            id: "percentageForTheHouse", // Percentage of revenue allocated to the house
                            header: _("Porcentaje de la casa"),
                            width: 180
                        },
                        {
                            id: "CommissionOfTheHouse", // Commission amount earned by the house
                            header: _("Comisíon de la casa"),
                            width: 180
                        },
                        {
                            id: "GGR", // Gross Gaming Revenue generated by the Penka
                            header: _("GGR (Gross Gaming Revenue)"),
                            width: 180
                        },
                        {
                            id: "totalBet", // Total bet amount column
                            header: _("Total Apostado"),
                            width: 160,
                            format: webix.i18n.priceFormat,
                            footer: { content: "summColumn" }
                        },
                        {
                            id: "totalPrizes", // Total prizes column
                            header: _("Total de Premios"),
                            width: 160,
                            format: webix.i18n.priceFormat,
                            footer: { content: "summColumn" }
                        },
                        {
                            id: "commissionBillable", // Commission billable column
                            header: _("Comisión Facturable"),
                            width: 160,
                            format: webix.i18n.priceFormat,
                            footer: { content: "summColumn" }
                        },
                        {
                            id: "dateRegistration", // First registration date column
                            header: _("Fecha de creación"),
                            width: 180
                        },
                        {
                            id: "dateModified", // Last modification date column
                            header: _("Fecha Última Modificación"),
                            width: 200
                        }
                    ],
                    onClick: {
                        detailBtn: function (e, id) { // Event for detail button click
                            const item = this.getItem(id);
                            vthis.showDetail(item.forecastId);
                        }
                    },
                    on: {
                        onBeforeLoad: function () { // Show loading overlay before data loads
                            this.showOverlay(
                                "<div id='contenedor' class='container-preload'>" +
                                "<div style='position: fixed; top: calc(50% - 57px); left: calc(50% - 60px); width: 120px;' class='progress'>" +
                                "<div class='icon-preload girando'></div>" +
                                "<div class='load-text'>Loading... </div>" +
                                "</div>" +
                                "</div>"
                            );
                        },
                        onAfterLoad: function () { // Hide overlay and show empty message if no data
                            this.hideOverlay();
                            if (this.$scope._filterApplied && !this.count()) {   // 👈 using flag
                                webix.extend(this, webix.OverlayBox);
                                this.showOverlay("<div class='no-data' style='margin:75px; font-size:18px;'>" + _("No hay datos") + "</div>");
                            }
                        }
                    }
                },
                {
                    view: "pager", // Pager for datatable
                    id: "pagerA",
                    size: devConfig.getDefaultDataFetch(), // Default page size
                    group: 5 // Show page numbers in groups of 5
                }
            ]
        };
    }

    /**
     * Initializes the view and fetches necessary data
     */
    init() {
        this._filterApplied = false; // Flag to track if filters are applied
        const grid = $$("datatable"); // Reference to main datatable
        const urlResumido = devConfig.geturlApi() + "Report/SportsForecastReport"; // API endpoint for summarized report

        // Event listener: apply filters to summarized report
        this.on(this.app, "sportsPoolReport:filter", (filterData) => {
            this._filterApplied = true;
            const pager = grid.getPager(); // Get pager of main datatable
            const start = pager.config.page * pager.config.size; // Calculate offset
            const count = pager.config.size; // Get page size

            grid.clearAll(); // Clear datatable before loading new data
            grid.load(function (params) {
                return webix.ajax()
                    .get(
                        urlResumido +
                        `?start=${start}&count=${count}` + // Pagination params
                        this.buildFilterQuery(filterData), // Append filter query
                        params
                    )
                    .then(function (res) {
                        const json = res.json(); // Parse JSON response
                        return {
                            pos: json.pos, // Position for virtual scrolling
                            total_count: json.total_count, // Total records
                            data: json.Data // Data array
                        };
                    });
            }.bind(this));
        });

        // Event listener: apply filters to detailed report
        this.on(this.app, "sportsPoolReportDetail:filter", (filterData) => {
            const gridDetail = $$("datatableDetail"); // Reference to detailed datatable
            if (gridDetail && this._lastForecastId) {
                this._filterApplied = true;

                const pager = gridDetail.getPager(); // Get pager of detail datatable
                const start = pager.config.page * pager.config.size; // Offset
                const count = pager.config.size; // Page size

                pager.select(0); // Reset to first page
                gridDetail.clearAll(); // Clear before reload
                gridDetail.load((params) => {
                    let query = ""; // Extra query string

                    if (filterData.userId) query += `&userId=${filterData.userId}`; // Filter by userId
                    if (filterData.state) query += `&state=${filterData.state}`; // Filter by state
                    if (filterData.penkaCode) query += `&penkaCode=${filterData.penkaCode}`; // Filter by penkaCode

                    return webix.ajax()
                        .get(
                            devConfig.geturlApi() +
                            "Report/SportsForecastReportDetail" + // API endpoint for detailed report
                            `?forecastId=${this._lastForecastId}&start=${start}&count=${count}${query}` +
                            this.buildFilterQuery(filterData), // Append additional filters
                            params
                        )
                        .then((res) => {
                            const json = res.json(); // Parse JSON response
                            return {
                                pos: json.pos, // Position for virtual scrolling
                                total_count: json.total_count, // Total records
                                data: json.Data // Data array
                            };
                        });
                });
            }
        });
    }

    buildFilterQuery(filterData) {
        // Base query always includes partner and country from profile
        let query = `&partner=${profile.PartnerSelected}&country=${profile.Settings.ReportCountry}`;

        // If typeDate is not 2, build query using date range from Datepicker
        if (profile.typeDate !== 2 && filterData.Datepicker) {
            const range = filterData.Datepicker.split(" - "); // Split range
            const from = moment(range[0]).format("YYYY-MM-DD"); // Start date
            const to = moment(range[1]).format("YYYY-MM-DD"); // End date
            query += `&dateFrom=${from}&dateTo=${to}`;
        }

        if (filterData.StartDateRange) {
            const range = filterData.StartDateRange.split(" - ");

            const from = moment(range[0]).format("YYYY-MM-DD");
            const to = moment(range[1]).format("YYYY-MM-DD");

            query += `&PenkaStartDate=${from}&PenkaEndDate=${to}`;
        }
        // If typeDate is 2, use single Date field for both from/to
        if (profile.typeDate === 2 && filterData.Date) {
            const dateOnly = moment(filterData.Date).format("YYYY-MM-DD");
            query += `&dateFrom=${dateOnly}&dateTo=${dateOnly}`;
        }

        // Add forecastId filter if present
        if (filterData.forecastId) {
            query += `&forecastId=${filterData.forecastId}`;
        }

        // Add penkaCode filter if present
        if (filterData.penkaCode) {
            query += `&penkaCode=${filterData.penkaCode}`;
        }

        // Add state filter if present
        if (filterData.state) {
            query += `&state=${filterData.state}`;
        }
        
        if (filterData.orderby) {
            query += `&orderby=${filterData.orderby}`;
        }

        // Add order
        if (filterData.order) {
            query += `&order=${filterData.order}`;
        }

        return query; // Return full query string
    }

    showDetail(forecastId) {
        this._lastForecastId = forecastId; // Store last forecast ID for later use
        const gridDetail = $$("datatableDetail"); // Reference to detail datatable

        if (gridDetail) {
            const pager = gridDetail.getPager(); // Get pager of detail datatable
            const start = pager.config.page * pager.config.size; // Offset for pagination
            const count = pager.config.size; // Page size

            gridDetail.clearAll(); // Clear previous data
            gridDetail.load((params) => {
                // Load detailed report data from API
                return webix.ajax()
                    .get(
                        devConfig.geturlApi() +
                        "Report/SportsForecastReportDetail" + // API endpoint for detail
                        `?forecastId=${forecastId}&start=${start}&count=${count}&partner=${profile.PartnerSelected}&country=${profile.Settings.ReportCountry}`,
                        params
                    )
                    .then((res) => {
                        const json = res.json(); // Parse JSON response
                        return {
                            pos: json.pos, // Position for virtual scrolling
                            total_count: json.total_count, // Total records
                            data: json.Data // Data array
                        };
                    });
            });

            $$("dColl").expand(); // Expand the detail accordion section
        }
    }
}
